// extracted by mini-css-extract-plugin
export var wrapper = "Navbar-module--wrapper--U0Tre";
export var link = "Navbar-module--link--MbtMm";
export var linkContainer = "Navbar-module--linkContainer--P-MM+";
export var prevIcon = "Navbar-module--prevIcon--3Hvp0";
export var logo = "Navbar-module--logo--Rat2g";